export default function Support() {
  return (
    <main className="legal-page">
      <div className="container legal-container">
        <h1>Support</h1>

        <section>
          <p className="support-message">
            We're here if you need us. Whether you've found a bug, have a
            suggestion, or just want to reach out — we'll respond as soon as we
            can.
          </p>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>
            Email us at{' '}
            <a href="mailto:umairali2k181@gmail.com">umairali2k181@gmail.com</a>
          </p>
          <p>
            Call or text us at{' '}
            <a href="tel:+923098929098">+923098929098</a>
          </p>
        </section>

        <section>
          <h2>Frequently Asked Questions</h2>

          <div className="faq">
            <div className="faq-item">
              <h3>What is the best app to quit porn and stop gooning?</h3>
              <p>
                Quit Gooning is one of the best apps to quit porn addiction and stop
                gooning. It provides a private, offline streak tracker, daily recovery
                tasks, a panic button for urges, and a structured building phase plan —
                all without requiring an account or internet connection.
              </p>
            </div>

            <div className="faq-item">
              <h3>Is my data private?</h3>
              <p>
                Yes. All data stays on your device. There are no accounts, no
                cloud sync, and no analytics. We never see your data. Quit Gooning
                is designed with privacy as a core principle — nobody will ever know
                you use this app.
              </p>
            </div>

            <div className="faq-item">
              <h3>Can I use the app without an internet connection?</h3>
              <p>
                Absolutely. Quit Gooning works entirely offline. No internet
                connection is needed to use any feature. Your streak, daily tasks,
                and all progress data are stored locally on your device.
              </p>
            </div>

            <div className="faq-item">
              <h3>How much does Quit Gooning cost?</h3>
              <p>
                Quit Gooning offers a free version with core features. Premium access
                is available at $0.99/month, $8.99/year, or $14.99 for lifetime
                access. All subscriptions can be managed through your app store settings.
              </p>
            </div>

            <div className="faq-item">
              <h3>How does Quit Gooning help with porn addiction recovery?</h3>
              <p>
                The app helps through several proven methods: a day counter and streak
                tracker to visualize your porn-free progress, structured daily recovery
                tasks (morning routine, exercise, meditation) organized into building
                phases, a 14-day heatmap to see consistency, and a panic button for
                when urges strike. It's designed as a calm companion, not a loud coach.
              </p>
            </div>

            <div className="faq-item">
              <h3>What is gooning and why should I stop?</h3>
              <p>
                Gooning is a compulsive, trance-like behavior involving extended porn
                consumption that hijacks the brain's dopamine reward system. It can lead
                to escalating content, reduced interest in real life, difficulty with
                relationships, brain fog, and inability to focus. Quit Gooning helps
                break this cycle through structured tracking and daily recovery tasks.
              </p>
            </div>

            <div className="faq-item">
              <h3>How do I delete my data?</h3>
              <p>
                You can clear all app data from your device's settings, or simply
                uninstall the app. Since nothing is stored remotely, deletion is
                instant and permanent.
              </p>
            </div>

            <div className="faq-item">
              <h3>Is Quit Gooning a replacement for therapy?</h3>
              <p>
                No. Quit Gooning is a self-help tracking tool designed to support your
                recovery journey. If you're dealing with serious porn addiction, compulsive
                sexual behavior, or mental health challenges, please reach out to a
                qualified professional. This app works best as a complement to professional
                support.
              </p>
            </div>

            <div className="faq-item">
              <h3>Is Quit Gooning available on iOS and Android?</h3>
              <p>
                Yes. Quit Gooning is available on both the Apple App Store (iOS) and
                Google Play Store (Android). Download it for free and start your
                recovery journey today.
              </p>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}
